import { useBehavior } from '@libs/hooks';
import { TCommonData, TLayout, TWidgetProps } from '@libs/types';
import clsx from 'clsx';
import React from 'react';
import { TLayoutOption } from '../../types/options';
import { getInlineStyles } from '../../utils/styles';
import styles from './floatingLayout.module.css';
import { useSkipFirstRender } from '@libs/utils';

export const FloatingLayout: React.FC<TWidgetProps<TCommonData, TLayoutOption> & TLayout> = ({ widget, children, margin }) => {
    const options = widget.options || {};
    const { isHidden } = useBehavior(widget);
    const firstRender = useSkipFirstRender(isHidden);

    const classNames = clsx(
        styles.floatingLayout,
        options.alignment === 'top' && styles.top,
        options.alignment === 'bottom' && styles.bottom,
        options.alignment === 'top' && styles.zIndexTop,
        !firstRender && isHidden && options.alignment === 'top' && styles.fadeOutTop,
        !firstRender && isHidden && options.alignment !== 'top' && styles.fadeOut,
        !firstRender && !isHidden && options.alignment === 'top' && styles.fadeInTop,
        !firstRender && !isHidden && options.alignment !== 'top' && styles.fadeIn,
    );
    return (
        <div data-test={widget.uid} className={classNames} style={getInlineStyles({ margin })}>
            <div className={styles.floatingLayoutInner}>{children}</div>
        </div>
    );
};
